import { render, staticRenderFns } from "./blindFaction.vue?vue&type=template&id=4abed483&"
import script from "./blindFaction.vue?vue&type=script&lang=js&"
export * from "./blindFaction.vue?vue&type=script&lang=js&"
import style0 from "./blindFaction.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports